<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <!-- <div slot="header">
            <strong> Coordinator User</strong>
            <div class="card-header-actions" > 
        
             <b-button size="sm" v-if="user_type==3 || user_type==2" class="btn btn-sm btn-primary mr-4 btn-pill" data-toggle="tooltip" title="Add New Coordinator" variant='primary' @click="addCoordinator()" :disabled="isReadOnly">Add New</b-button>              
             
               <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" data-toggle="tooltip" title="Refresh"  type="button"><i class="fa fa-refresh"></i></button>
            </div>
          </div>  -->

           <div slot="header" class="row w-100 align-items-center">
    
                <!-- Left Side -->
                <div class="col-md-9">
                    <strong class="mr-3">Coordinator User</strong>

                    <b-button size="sm" v-if="user_type==3 || user_type==2" class="btn btn-sm btn-primary mr-4 btn-pill" data-toggle="tooltip" title="Add New Coordinator" variant='primary' @click="addCoordinator()" :disabled="isReadOnly">Add New</b-button>              
                
                  <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" data-toggle="tooltip" title="Refresh"  type="button"><i class="fa fa-refresh"></i></button>
                </div>

                <!-- Right Side -->
                <div class="col-md-3 text-right" >
                    <button
                        class="btn btn-sm"
                        style="color: blue; border: 1px solid red; background-color: transparent;"
                        @click="showmltiselectpopup = true, getuserlistcoordinatorformultiselect()"
                        type="button"
                    >
                        Multiple User Active/Inactive
                    </button>
                </div>

            </div>
          <b-collapse id="my-collapse">
           <b-card>
            <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col sm="3">
                  <b-form-group>
                    <!-- v-if="user_type==2" -->
                    <!-- v-if="user_type==2" -->
                        <label for="usertype">User Type</label>
                          <b-form-select  v-model="customer.usertype" name="usertype" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.usertype') }">
                          <option :value='selected'>-- Select UserType --</option>
                          <option value="3" >Coordinator</option>   
                          <option value="4" >Sub Coordinator</option>           
                        </b-form-select>
                      
                       <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.usertype')" >{{ errors.first('form-1.usertype') }}</i>

                      </span>
                      
                      </b-input-group>
                  </b-form-group>

                </b-col>
                <b-col sm="3">
                  <b-form-group>
                      <label for="firstname">First Name</label>
                      <b-form-input type="text" name="firstname" v-model="customer.firstname" v-validate="'required|alpha|min:3|max:30'" :class="{'input': true, 'is-invalid': errors.has('form-1.firstname') }" placeholder="Enter First Name">                       
                       </b-form-input>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.firstname')" >{{ errors.first('form-1.firstname') }}</i>

                      </span>
                      
                      </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="3">
                    <b-form-group>
                      <label for="lastname">Last Name</label>                     
                        <b-form-input class="input" type="text" name="lastname" v-model="customer.lastname" v-validate="'required|alpha|min:3|max:30'" :class="{'input': true, 'is-invalid': errors.has('form-1.lastname') }" placeholder="Enter Last Name">
                        </b-form-input>
                     
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.lastname')" >{{ errors.first('form-1.lastname') }}</i>
                        
                      </span>
                      
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="sysemailid">Email id</label>                     
                        <b-form-input class="input" type="text" name="sysemailid" v-model="customer.sysemailid" v-validate="'required|email'" :class="{'input': true, 'is-invalid': errors.has('form-1.sysemailid') }" placeholder="Enter Email id">
                        </b-form-input>
                      
                       <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.sysemailid')" >{{ errors.first('form-1.sysemailid') }}</i>
                        
                      </span>
                      </b-input-group>
                     
                      </b-form-group>
                  </b-col>
                  
              </b-row>
              <b-row>
                <b-col sm="3">
                    <b-form-group>
                      <label for="mobilenumber">Mobile Number</label>
                      
                          <b-form-input class="input" type="text"  name="mobilenumber" maxlength="10" v-model="customer.mobilenumber" v-validate="'required|digits:10'" :class="{'input': true, 'is-invalid': errors.has('form-1.mobilenumber') }" placeholder="Enter Mobile Number" >
                          </b-form-input>  
                      
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.mobilenumber')" >{{ errors.first('form-1.mobilenumber') }}</i>
                        
                      </span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="Password">Password</label>
                      
                         <b-form-input class="input" type="password" name="syspassword" minlength="6" maxlength="14" v-model="customer.syspassword" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.syspassword') }" placeholder="Enter Password">
                         </b-form-input>
                      
                      <b-input-group class="mb-3">
                       <span class="icon has-text-warning">
                        <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.syspassword')" >{{ errors.first('form-1.syspassword') }}</i>
                        
                      </span>                    
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                      <b-form-group>
                        <label for="status">Status</label>
                       
                          <b-form-select v-model="customer.isactive" name="status" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.status') }">
                          <option value="customer.isactive">--Select--</option>
                          <option value="1">Active</option>
                          <option value="0">InActive</option>
                        </b-form-select>
                       
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                        <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.status')" >{{ errors.first('form-1.status') }}</i>
                        
                      </span>
                        </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                  <div id='container' style="margin-top:32px;width:180px">
                 <b-form-group > 
                  <!-- <ejs-multiselect id='multiselect' placeholder="Select City" name="valueCity" v-model="valueCity" :dataSource='optionsCity' :fields='fieldCity' @change="selectedCity(valueCity)" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.valueCity') }" 
                  ></ejs-multiselect> -->
                  <ejs-multiselect
                  id="multi_select2"
                  name="valueCity"
                  placeholder="Select city"
                  v-model="valueCity"
                  :dataSource="optionsCity"
                  @change="selectedCity(valueCity)"
                  :showSelectAll="showSelectAll"
                  selectAllText="Select All"
                  unSelectAllText="unSelect All"
                  :fields="fieldCity"
                  :allowCustomValue="allowCustomValue"
                  enableGroupCheckBox="true"
                  mode="CheckBox" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.valueCity') }"
                ></ejs-multiselect>
                  <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                        <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.valueCity')" >{{ errors.first('form-1.valueCity') }}</i>
                        
                      </span>
                        </b-input-group>
               </b-form-group>  
                 </div>
               </b-col>
                 
              </b-row>
              <b-row>
                <b-col sm="3" v-if="valueCity.length>0 ">
                  <div id='container' >
                    <b-form-group > 
                    <!-- <ejs-multiselect  id='multiselect_1'  placeholder="Select WareHouse" name="valueWH" v-model="valueWH" :dataSource='optionsWH'  :fields='fieldWH' @change="selectedWH(valueWH)" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('form-1.valueWH') }" 
                    ></ejs-multiselect> -->
                    <ejs-multiselect
                    id="multi_select2"
                    name="valueWH"
                    placeholder="Select WareHouse"
                    v-model="valueWH"
                    :dataSource="optionsWH"
                    @change="selectedWH(valueWH)"
                    :showSelectAll="showSelectAll"
                    selectAllText="Select All"
                    unSelectAllText="unSelect All"
                    :fields="fieldWH"
                    :allowCustomValue="allowCustomValue"
                    enableGroupCheckBox="true"
                    mode="CheckBox" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('form-1.valueWH') }"
                  ></ejs-multiselect>
                    <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                        <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.valueWH')" >{{ errors.first('form-1.valueWH') }}</i>
                        
                      </span>
                        </b-input-group>
                  </b-form-group>
                  </div>
                </b-col> 
                <b-col sm="3">
                  <b-form-group label="Employment Type">
                    <b-form-radio-group
                      v-model="employmentType"
                      :options="[
                        { text: 'Permanent', value: 'Permanent' },
                        { text: 'Contract', value: 'Contract' }
                      ]"
                      name="employmentType"
                      v-validate="'required'"
                      :class="{ 'is-invalid': errors.has('form-1.employmentType') }"
                    ></b-form-radio-group>
                    <span class="text-danger" v-show="errors.has('form-1.employmentType')">
                      {{ errors.first('form-1.employmentType') }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col sm="3" v-if="employmentType === 'Contract'">
                  <b-form-group label="Employee ID">
                    <b-form-input
                       type="text"
                       name="empId"
                       v-model="customer.empId"
                       v-validate="'required|numeric'"
                       :class="{ 'is-invalid': errors.has('form-1.empId') }"
                       placeholder="Enter Employee ID"
                       @input="customer.empId = customer.empId.replace(/\D/g, '')"
                      @keypress="onlyNumberInput"
                     ></b-form-input>
                    <span class="text-danger" v-show="errors.has('form-1.empId')">
                      {{ errors.first('form-1.empId') }}
                    </span>
                  </b-form-group>
  <div class="mt-1 text-primary font-weight-bold">

    {{ this.selectedHUB + 'RB-' + customer.empId }}
  </div>
                </b-col>
                <b-col sm="3" v-if="employmentType === 'Contract'">
                  <b-form-group label="Date of Joining:" >
                    <v-date-picker
                      mode="single"
                      input-class="dateInput"
                      v-model="customer.dateofjoining"
                      :available-dates="{ start: null, end: new Date(new Date().setDate(new Date().getDate() - 0)) }"
                      :input-props="{ readonly: true, placeholder: 'Select Date of Joining' }"
                      :masks="{ input: 'YYYY-MM-DD' }"
                      :input-format="formatDate"
                       v-validate="'required'"
                      name="dateofjoining"
                      :class="{ 'is-invalid': errors.has('form-1.dateofjoining') }" 
                    />
                    <span class="text-danger" v-show="errors.has('form-1.dateofjoining')">
                      {{ errors.first('form-1.dateofjoining') }}
                    </span>
                  </b-form-group>
                </b-col>
                
              </b-row>
              <footer class="column has-text-right">
                <b-button variant="primary" size="md"  type="submit">Save</b-button>
                </footer>
            </b-form>
        </b-card>
      </b-collapse>
          
            <b-row>
             <b-col md="3" class="my-1">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col sm="9" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> </p>
               <!-- this.totalRows  -->
              </b-col>

              <b-col md="12">
                <b-table show-empty responsive   :items="coodinatorItems" :busy="isBusy"    :current-page="currentPage"  :fields="fields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered"  id="my-table"> 

                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div> 
                <template slot="user_type" slot-scope="row">
                  <span >{{row.item.user_type == 3 ? 'Coordinator': row.item.user_type == 4 ? 'SubCoordinator':''}}</span>
                  
                </template> 

                <template slot="user_status" slot-scope="row">

                    <span data-toggle="tooltip" title="InActive" v-if="row.item.isactive == '0'" style="cursor:pointer;">
                        <span class="badge badge-danger">Inative</span>
                    </span>
                    <span data-toggle="tooltip" title="Active" v-if="row.item.isactive == '1'" style="cursor:pointer;">
                        <span class="badge badge-success">Active</span>
                    </span>
                  </template>
                <template slot="zoneid" slot-scope="row">
                   <button  title="View Zone Listing" @click="viewZoneList(row.item.zoneid)" style="background-color:white !important;" class="btn btn-link"  >
                  <span style="color:#1b8eb7"> {{row.item.zoneid}}</span>
               
               </button>
                </template>
                
                 <template slot="actions" slot-scope="row">
                   <!-- <b-button size="sm" class="mr-1"  href=""  data-toggle="tooltip" title="Add Pincodes" @click="assignPincodes(row.item)" > <i class="fa fa fa-pencil-square-o" ></i>
                  </b-button>  -->
                  <b-button :disabled="isReadOnly"
                size="sm"
                @click="editinfoModal(row.item)"
                data-toggle="tooltip"
                title="Update User Info"
                class="mr-1"
                style="background: #b0c4de !important;color: #000 !important;"
              >
                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
              </b-button>
              <div v-if="isReadOnly">
                <b-button size="sm"  :disabled="isReadOnly"
                data-toggle="tooltip" title="Assign PDA Module Access"
                style="background: #b0c4de !important;color: #000 !important;">
                <i class="fa fa-mobile" aria-hidden="true"></i>
                </b-button>
              </div>
              <div v-else>
                <router-link :to="'/pdamoduleaccess/' + row.item.sysusermasterid + ' ' + row.item.user_type">
                  <b-button size="sm" 
                  data-toggle="tooltip" title="Assign PDA Module Access"
                  style="background: #b0c4de !important;color: #000 !important;">
                  <i class="fa fa-mobile" aria-hidden="true"></i>
                  </b-button></router-link>
              </div>
                 </template>
                 <template slot="camsStatus" slot-scope="row">        
                  <b-badge
                    :variant="row.item.pushed_on_cams=='Yes' ? 'success' : 'danger'"
                    class="text-capitalize"
                  >
                    {{ row.item.pushed_on_cams }}
                  </b-badge>
                 {{ row.item.createdby }}<p> {{ formatDate(row.item.createddate) }}</p>


                </template>
              </b-table>
            </b-col>

            <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>

            <b-modal title="Pincode Allocation"  v-model="pincodeAloocationModal" size="md" @ok="pincodeAloocationModal = false" class="modal-info" ok-variant="info" hide-footer>
      
              <template slot="default" slot-scope="{ hide }">
               <b-form @submit.prevent="validateForm2('form-2')" data-vv-scope="form-2">
              <div id='container' style="width:100%;">
                <br>  
                <b-form-group label="Assign Pincodes"
                    :label-cols="3">   
                <ejs-multiselect id='multiselect' placeholder="Assign Pincodes" name="pincodes" v-model="assignedPincode"   :dataSource='optionsPincodes'     :fields='getPincodesFields'  v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('form-2.pincodes') }">
                </ejs-multiselect>
                <span v-show="errors.has('form-2.pincodes')" class="help text-danger">{{ errors.first('form-2.pincodes') }}</span>
                 </b-form-group>  
              </div>
            
                 <div slot="footer" class="text-right">
                  <b-button type="submit" size="sm" class="mr-4" variant="primary">Assign</b-button>
                  <b-button size="sm" variant="danger"  @click="CloseAllocatePincodeModal">
                   Cancel
                  </b-button>
                 </div>
              <div id="overlayModal" >
                <div class="loaderModal"></div>
              </div>
                </b-form>
             </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="sm" variant="danger"  style="display:none" >
            Cancel
          </b-button>
          <!-- Button with custom close trigger value -->
        </template>
      </b-modal>
       <b-modal title="Zone Listing"  v-model="viewZone" size="lg" @ok="viewZone = false" class="modal-info" ok-variant="info" hide-footer>
         <template slot="default" slot-scope="{ hide }">
       <b-row>
       <b-col sm="12" class="text-right">
               <p> <b>Total Records :<span style="color:red;"> {{zonetotalRows}}</span></b> </p>
              </b-col>   
      <b-col sm="12"> 
        <!-- <b-col sm="12"> -->
      <b-table show-empty stacked="md"  :items="zoneitems"  :fields="zonefields"  :current-page="zonecurrentPage"  :per-page="zoneperPage"     :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusyzone" >
        <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div> 
          <template slot="mpscount" slot-scope="row">
                   <button  title="View MPS Count List" @click="viewMPSList(row.item.parentawb)" style="background-color:white !important;" class="btn btn-link"  >
                  <span style="color:#1b8eb7"> {{row.item.mpscount}}</span>
               
               </button>
          </template>
             
      </b-table> 
    <!-- </b-col> -->
    </b-col>
     </b-row> 
       <b-row>
       <b-col md="6" class="my-1" v-if="zonetotalRows>10">
        <b-pagination
              v-model="zonecurrentPage"
              :total-rows="zonetotalRows"
              :per-page="zoneperPage"
              class="my-0"
            ></b-pagination>
           
      </b-col> 
    </b-row>
         <div class="col-md-12 pull-right"> 
                <div slot="footer" class="text-right">
                
                  <b-button  size="sm" variant="danger" @click="modalCancel()">Close</b-button>
                </div>
              </div>
      </template>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" variant="danger" @click="modalCancel()" style="display:none">
          Cancel
        </b-button>
      </template>
       </b-modal>

       <b-modal title="MPS Count Listing"  v-model="viewMPSCout" size="lg" @ok="viewMPSCout = false" class="modal-info" ok-variant="info" hide-footer>
         <template slot="default" slot-scope="{ hide }">
       <b-row>
       <b-col sm="12" class="text-right">
               <p> <b>Total Records :<span style="color:red;"> {{mpstotalRows}}</span></b> </p>
              </b-col>   
      <b-col sm="12"> 
        <!-- <b-col sm="12"> -->
      <b-table show-empty stacked="md"  :items="mpsitems"  :fields="mpsfields"  :current-page="mpscurrentPage"  :per-page="mpsperPage"     :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusymps" >
        <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div> 
         
      </b-table> 
    <!-- </b-col> -->
    </b-col>
     </b-row> 
       <b-row>
       <b-col md="6" class="my-1" v-if="mpstotalRows>10">
        <b-pagination
              v-model="mpscurrentPage"
              :total-rows="mpstotalRows"
              :per-page="mpsperPage"
              class="my-0"
            ></b-pagination>
           
      </b-col> 
    </b-row>
         <div class="col-md-12 pull-right"> 
                <div slot="footer" class="text-right">
                
                  <b-button  size="sm" variant="danger" @click="mpsmodalCancel()">Close</b-button>
                </div>
              </div>
      </template>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" variant="danger" @click="modalCancel()" style="display:none">
          Cancel
        </b-button>
      </template>
       </b-modal>
              
       <b-modal
       title="Update User Info"
       v-model="editAgentMaster"
       @ok="editcancel()"
       hide-footer size="xl"
     >
       <template slot="default" slot-scope="{ hide }">
         <b-form
           @submit.prevent="validateForm5('form-5')"
           data-vv-scope="form-5"
         >

         <b-row>

           <b-col sm="4" v-if="Customer.editusertype=='3'">
             <b-form-group
           >
           <label for="User Type">User Type</label>
             <b-form-select
               v-model="Customer.editusertype"
               name="editusertype"
               :class="{
                 input: true,
                 'is-invalid': errors.has('form-5.editusertype'),
               }" disabled
             >
               <option value="3">Coordinator</option>
               <!-- <option value="4">Sub-Coordinator</option> -->
             </b-form-select>
             <b-input-group class="mb-3">
               <span class="icon has-text-warning">
                 <i
                   class="fa fa-warning help text-danger"
                   v-show="errors.has('form-5.editusertype')"
                   >{{ errors.first("form-5.editusertype") }}</i
                 >
               </span>
             </b-input-group>
           </b-form-group>
           </b-col>
           <b-col sm="4" v-else>
            <b-form-group
          >
          <label for="User Type">User Type</label>
            <b-form-select
              v-model="Customer.editusertype"
              name="editusertype"
              :class="{
                input: true,
                'is-invalid': errors.has('form-5.editusertype'),
              }"
            >
              <option value="3">Coordinator</option>
              <option value="4">Sub-Coordinator</option>
            </b-form-select>
            <b-input-group class="mb-3">
              <span class="icon has-text-warning">
                <i
                  class="fa fa-warning help text-danger"
                  v-show="errors.has('form-5.editusertype')"
                  >{{ errors.first("form-5.editusertype") }}</i
                >
              </span>
            </b-input-group>
          </b-form-group>
          </b-col>

           <b-col sm="4">
             <b-form-group>
               <label for="first name">First Name</label>
               <b-form-input
                 type="text"
                 name="first name"
                 v-model="Customer.first_name"
                 v-validate="'required|alpha|min:3|max:30'"
                 :class="{
                   input: true,
                   'is-invalid': errors.has('form-5.first name'),
                 }"
                 placeholder="Enter First Name"
               >
               </b-form-input>
               <b-input-group class="mb-3">
                 <span class="icon has-text-warning">
                   <i
                     class="fa fa-warning help text-danger"
                     v-show="errors.has('form-5.first name')"
                     >{{ errors.first("form-5.first name") }}</i
                   >
                 </span>
               </b-input-group>
             </b-form-group>
           </b-col>

           <b-col sm="4">
             <b-form-group>
               <label for="last name">Last Name</label>
               <b-form-input
                 class="input"
                 type="text"
                 name="last name"
                 v-model="Customer.last_name"
                 v-validate="'required|alpha|min:3|max:30'"
                 :class="{
                   input: true,
                   'is-invalid': errors.has('form-5.first name'),
                 }"
                 placeholder="Enter Last Name"
               >
               </b-form-input>

               <b-input-group class="mb-3">
                 <span class="icon has-text-warning">
                   <i
                     class="fa fa-warning help text-danger"
                     v-show="errors.has('form-5.last name')"
                     >{{ errors.first("form-5.last name") }}</i
                   >
                 </span>
               </b-input-group>
             </b-form-group>
           </b-col>
           <b-col sm="4">
             <b-form-group>
               <label for="sysemailid">Email id</label>

               <b-form-input
                 class="input"
                 type="text"
                 name="email_id"
                 v-model="Customer.email_id"
                 v-validate="'required|email'"
                 :class="{
                   input: true,
                   'is-invalid': errors.has('form-5.email_id'),
                 }"
                 placeholder="Enter Email id"
               >
               </b-form-input>

               <b-input-group class="mb-3">
                 <span class="icon has-text-warning">
                   <i
                     class="fa fa-warning help text-danger"
                     v-show="errors.has('form-5.email_id')"
                     >{{ errors.first("form-5.email_id") }}</i
                   >
                 </span>
               </b-input-group>
             </b-form-group>
           </b-col>

           <b-col sm="4">
             <b-form-group>
               <label for="usermobilenumber">Mobile Number</label>

               <b-form-input
                 class="input"
                 type="text"
                 id="usermobilenumber"
                 name="mobile number"
                 maxlength="10"
                 v-model="Customer.mobile_no"
                 v-validate="'required|digits:10'"
                 :class="{
                   input: true,
                   'is-invalid': errors.has('form-5.mobile number'),
                 }"
                 placeholder="Enter Mobile Number"
               >
               </b-form-input>

               <b-input-group class="mb-3">
                 <span class="icon has-text-warning">
                   <i
                     class="fa fa-warning help text-danger"
                     v-show="errors.has('form-5.mobile number')"
                     >{{ errors.first("form-5.mobile number") }}</i
                   >
                 </span>
               </b-input-group>
             </b-form-group>
           </b-col>

           <b-col sm="4">
             <b-form-group>
               <label for="status">Status</label>

               <b-form-select
                 v-model="Customer.editisactive"
                 name="status"
                 v-validate="'required|'"
                 :class="{
                   input: true,
                   'is-invalid': errors.has('form-5.status'),
                 }"
               >
                 <option value="selectstatus">--Select--</option>
                 <option value="1">Active</option>
                 <option value="0">InActive</option>
               </b-form-select>

               <b-input-group class="mb-3">
                 <span class="icon has-text-warning">
                   <i
                     class="fa fa-warning help text-danger"
                     v-show="errors.has('form-5.status')"
                     >{{ errors.first("form-5.status") }}</i
                   >
                 </span>
               </b-input-group>
             </b-form-group>
           </b-col>

           <!-- <b-col sm="6">
             <div id="container">
               <label>Select City</label>
               <ejs-multiselect
               id="multi_select1"
               placeholder="Select City"
               name="cityid"
               v-model="cityid"
               :dataSource="optionsCity"
               @change="selectedCityedit()"
               :fields="fieldCity"
               v-validate="'required|'"
                 :class="{
                   input: true,
                   'is-invalid': errors.has('form-5.cityid'),
                 }"
               >
               </ejs-multiselect>
             </div>
             <b-input-group class="mb-3">
               <span class="icon has-text-warning">
                 <i
                   class="fa fa-warning help text-danger"
                   v-show="errors.has('form-5.cityid')"
                   >{{ errors.first("form-5.cityid") }}</i
                 >
               </span>
             </b-input-group>
           </b-col>

           <b-col sm="6" v-if="cityid.length > 0">
             <div
               id="container">
             <label>Select WareHouse</label>
               <ejs-multiselect id="multi_select2" placeholder="Select Warehouse" name="warehouse"
                 v-model="valueWHedit"
                 @change="selectedWHedit(valueWHedit)"
                 :dataSource="optionsWHedit"
                 :fields="fieldWHedit"  v-validate="'required|'"
                 :class="{
                   input: true,
                   'is-invalid': errors.has('form-5.warehouse'),
                 }"
                 >
                 </ejs-multiselect>
             </div>
             <b-input-group class="mb-3">
               <span class="icon has-text-warning">
                 <i
                   class="fa fa-warning help text-danger"
                   v-show="errors.has('form-5.warehouse')"
                   >{{ errors.first("form-5.warehouse") }}</i
                 >
               </span>
             </b-input-group>
           </b-col> -->
           <b-col sm="6">
            <label>Select City</label>
            <div class="multiselect" ref="multiselect">
              <div class="select-box" @click="toggleDropdown">
                <span v-if="editvalueCity.length === 0">Select City</span>
                <div v-else  class="selected-cities">
                  <span v-for="(city, index) in editvalueCity" :key="index" style="font-size: 13px;
                    background: rgb(238, 238, 238);
                    padding: 3px 7px 2px 7px;
                    border-radius: 15px;
                    color: rgb(0, 0, 0);
                    margin: 5px;
                    word-wrap: break-word;">
                    {{ city }} <i class="fa fa-times" aria-hidden="true" @click="removeCity(city)"></i> 
                  </span>
                </div>
                <!-- <i class="arrow" :class="{'down': !showDropdown, 'up': showDropdown}"></i> -->
              </div>
              <div class="dropdown" v-show="showDropdown" ref="dropdown">
                <div>
                 <div style="border-bottom: 1px solid #ddd;" class="pl-3 mt-3">
                  <input type="checkbox" id="selectAllCheckbox" v-model="selectAllActive" @change="toggleSelectAll">&nbsp;
                  <label for="selectAllCheckbox">{{selectAllLabel}}</label>
                 </div>
                  <div v-for="(city, index) in editoptionsCity" :key="index" class="checkbox pl-3" >
                    <input type="checkbox" :id="'city'+index" v-model="editvalueCity" :value="city.city" @change="callfunction()">
                    <label :for="'city'+index">{{ city.city }}</label>
                  </div>
                </div>
              </div>
            </div>
            <span v-if="editvalueCity.length === 0" class="help text-danger"
              >The City field is required</span>
           </b-col>

            <b-col sm="6" v-if="editvalueCity.length > 0">
              <label>Select WareHouse</label>
              <div class="multiselect" ref="multiselectall">
                <div class="select-box" @click="toggleDropdown_wh">
                  <span v-if="editWarehouseid.length === 0">Select WareHouse</span>
                  <div v-else  class="selected-cities">
                    <span v-for="(wh, index) in editWarehouseid" :key="index" style="font-size: 13px;
                      background: rgb(238, 238, 238);
                      padding: 3px 7px 2px 7px;
                      border-radius: 15px;
                      color: rgb(0, 0, 0);
                      margin: 5px;
                      word-wrap: break-word;">
                      {{ wh.name }} <i class="fa fa-times" aria-hidden="true" @click="removeCity_wh(wh)"></i> 
                    </span>
                  </div>
                </div>
                <div class="dropdown" v-show="showDropdown_wh" ref="dropdown">
                  <div>
                   <div style="border-bottom: 1px solid #ddd;" class="pl-3 mt-3">
                    <input type="checkbox" id="selectAllCheckbox" v-model="selectAllActive_wh" @change="toggleSelectAll_wh">&nbsp;
                    <label for="selectAllCheckbox">{{selectAllLabel_wh}}</label>
                   </div>
                    <div v-for="(wh, index) in editWarehouseoption" :key="index" class="checkbox pl-3" >
                      <input type="checkbox" :id="'wh'+index" v-model="editWarehouseid" :value="wh" @change="checklength_wh">
                      <label :for="'wh'+index">{{ wh.name }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <span v-if="editWarehouseid.length === 0" class="help text-danger"
                >The WareHouse Id field is required</span>
              <br><br>
            </b-col>
         </b-row>

           <div slot="footer" class="text-right">
             <b-button
               type="submit"
               size="sm"
               class="mr-4"
               variant="primary"
             >
               Update</b-button
             >
             <b-button size="sm" variant="danger" @click="editcancel()"
               >cancel</b-button
             >
           </div>
           <div id="overlayModal">
             <div class="loaderModal"></div>
           </div>
         </b-form>
       </template>
       <template slot="modal-footer" slot-scope="{ hide }">
         <!-- Emulate built in modal footer ok and cancel button actions -->
         <b-button size="sm" style="display:none">
           Cancel
         </b-button>
         <!-- Button with custom close trigger value -->
       </template>
     </b-modal>

                  <!-- // Active Inactive -->
                <b-modal
              v-model="showmltiselectpopup"
              size="lg"
              no-close-on-backdrop
              no-close-on-esc
              hide-footer
          >
              <template #modal-header>
                  <h5>Multiple User Active/Inactive</h5>
              </template>

              <b-card>

                  <div class="mb-2">
                      <b-button
                          size="sm"
                          variant="primary"
                          @click="selectAllUsers"
                      >
                          Select All
                      </b-button>

                      <b-button
                          size="sm"
                          variant="danger"
                          class="ml-2"
                          @click="valuemultipleuser = []"
                      >
                          Clear
                      </b-button>
                  </div>

                  <v-select
                      v-model="valuemultipleuser"
                      :options="multiItems"
                      label="name"
                      multiple
                      :close-on-select="false"
                      :clearable="false"
                      :searchable="true"
                      placeholder="Select Users"
                  >

                      <!-- <template #option="{ name, selected }">
                          <div class="d-flex align-items-center">
                              <input
                                  type="checkbox"
                                  :checked="selected"
                                  readonly
                                  class="mr-2"
                              />
                              <span>{{ name }}</span>
                          </div>
                      </template> -->

                  </v-select>

              
                
                        <b-form-select class="mt-4"
                            v-model="userstatus"
                            name="userstatus"
                            v-validate="'required'"
                            :options="statusOptions"
                        >
                            <template #first>
                            <b-form-select-option :value="null">
                                Select Status
                            </b-form-select-option>
                            </template>
                        </b-form-select>

               


                     <div class="text-right mt-4">
                        <b-button :disabled="valuemultipleuser && valuemultipleuser.length == 0"
                            variant="success"
                            @click="saveSelectedUsers();"
                        >
                            Save
                        </b-button>

                        <b-button
                            variant="danger"
                            class="ml-2"
                            @click="showmltiselectpopup = false, valuemultipleuser = []"
                        >
                            Close
                        </b-button>
                    </div>


              </b-card>
          </b-modal>
            </b-row>
        </b-card>
       </b-col>
     </b-row>
   </div>
</template>
<script>
  import CONSTANTS from '@/utils/constants'
  import Utils from '@/utils'
  import Vue from 'vue'
  import vSelect from "vue-select";
  export default {
      components: {
        vSelect
    },
    data: function() {
      return {
        totalRows:0,
        selectedHUB:'',
        isBusy:false,
        currentPage:1,
        perPage:10,
        bordered:true,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        fields:[
              { key: 'sysusermasterid', label: 'User ID', sortable: true},
              { key: 'sysemailid', label: 'Email ID', sortable: true},
              { key: 'camsStatus', label: 'CAMS Status', sortable: true},
              { key: 'userfirstname', label: 'First Name', sortable: true},          
              { key: 'userlastname', label: 'Last Name', sortable: true },    
              { key: 'usermobilenumber', label: 'Mobile Number', sortable: true },
              { key: 'user_status',  label: 'Status', sortable: true},
              { key: 'user_type', label: 'User Type', sortable: true },
              // { key: 'isactive', label: ' Status' },
              { key: 'actions', label: ' Action' },
        ],
        coodinatorItems:[],
        select:'',
        customer:{
          usertype:"",
          firstname:"",
          lastname:"",
          sysemailid:"",
          mobilenumber:"",
          syspassword:"",
          isactive:"",
          empId: '',
          dateofjoining: '',
        },
        pincodeAloocationModal:false,
        selectAdmin:'',
        cityData:[],
        optionsCity:[],
        fieldWH:{ text: 'name', value: 'id' },
        fieldCity:{ text: 'city', value: 'city' },
        valueWH:[],
        temp_WHcity:[],
        optionsWH:[],
        WHData:[],
        valueCity:[],
        optionsCity:[],
        selected:"",
        pincodeAssigntoAdmin:[],
        coSystemid:'',
     
        optionsPincode:[],
        co_sysmaster_id:'',
   
        zone_id:'',
        viewZone:false,
        zoneitems:[],
        zonefields:[ 
        { key: 'parentawb', label: 'Parent Awb', sortable: true},
        { key: 'mpscount', label: 'MPS Count', sortable: true},
        ],
        zonecurrentPage:1,
        zoneperPage:10,
        isBusyzone:false,
        zonetotalRows:0,
        parent_awb:'',
        viewMPSCout:false,
        isBusymps:false,
        mpsitems:[],
        mpsfields:[
        { key: 'parentawb', label: 'Parent Awb', sortable: true},
        { key: 'shippingid', label: 'Shipping Id', sortable: true},
        ],
        mpscurrentPage:1,
        mpsperPage:10,
        mpstotalRows:0,
        assignedPincode:[],
        optionsPincodes:[],
        getPincodesFields:{ text: 'name', value: 'id' },
        coAssignPincode:[],
        user_type:'',
        ////////////////////////
        editAgentMaster: false,
        cityid :[],
        selected_Usertypeedit :'',
        editWH :[],
        editvalueWHupdate :[],
        optionsWHedit :[],
        fieldWHedit:{ text: "name", value: "id" },
        valueWHedit :[],
        editWHedit :[],
        warehouselistwiseobj :[],
        passwObj :{},
        
        cityData :[],
        optionsCity :[],
        Customer :{},



        editvalueCity:[],
        selectAllActive:false,
        showDropdown:false,
        editWarehouse:[],
        editCity:[],
        editvalueWH:[],
        editWarehouseoption:[],
        editWarehouseid:[],
        editoptionsCity:[],
        showDropdown_wh: false,
        selectAllActive_wh: false,
        valueWHcity:[],
        showSelectAll: true,
        employmentType:'Contract',
         showmltiselectpopup:false,
             multiItems: [],
            valuemultipleuser: [],
            userstatus:null,
            statusOptions: [
            { value: null, text: 'Select Status', disabled: true },
            { value: '1', text: 'Active' },
            { value: '0', text: 'Inactive' }
      ],
      }
    },
    mounted() {
      document.addEventListener('click', this.closeDropdownOnClickOutside);
      document.addEventListener('click', this.closeDropdownOnClickOutside_whall);
    },
    beforeDestroy() {
      document.removeEventListener('click', this.closeDropdownOnClickOutside);
      document.removeEventListener('click', this.closeDropdownOnClickOutside_whall);
    },
    created: function() {
      // var userdata = localStorage.getItem("userData");
      var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        console.log("userInfo",userInfo)
    this.accessBody = userInfo.body;
        console.log("--------->>>>>>>>>>",userInfo.body, this.route_id)
         if(userInfo.hub_id){
        this.selectedHUB=userInfo.hub_id;
        }
        this.ischeckbodyvalidation();
      this.coordinatorList();
      this.displayCity();
    },
    computed: {
      rows() {
        return this.coodinatorItems.length
      },
      selectAllLabel() {
        return this.editvalueCity.length === this.editoptionsCity.length ? 'Unselect All' : 'Select All';
      },
      selectAllLabel_wh() {
        console.log(this.editWarehouseid.length === this.editWarehouseoption.length,this.editWarehouseid.length,this.editWarehouseoption.length)
        return this.editWarehouseid.length === this.editWarehouseoption.length ? 'Unselect All' : 'Select All';
      }
    },

   methods: {
   formatDate(date) {
            if (!date) return ''
            const d = new Date(date)

            return d.toLocaleString('en-IN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
            })
        },
    ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                if (element.isReadonly==true) {
                this.isReadOnly=true;
                break; 
                }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.isReadonly==true) {
                    this.isReadOnly=true;
                    break; 
                }
                }
            }
            }
        },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    closeDropdownOnClickOutside(event) {
      const multiselect = this.$refs.multiselect;
      if (!(multiselect && multiselect.contains(event.target))) {
        this.showDropdown = false;
      }
    },
    removeCity(city) {
      const index = this.editvalueCity.indexOf(city);
      if (index !== -1) {
        this.editvalueCity.splice(index, 1);
      }
      this.warehouseListing()
      this.updateSelectAllActive();
    },
    toggleSelectAll() {
      if (this.selectAllActive) {
        this.editvalueCity = [];
        this.editvalueCity = this.editoptionsCity.map(city => city.city);
        this.warehouseListing()
      } else {
        this.editvalueCity = [];
      }
    },
    updateSelectAllActive() {
      // Update selectAllActive based on the number of selected cities
      this.selectAllActive = this.editvalueCity.length === this.editoptionsCity.length;
    },

    toggleDropdown_wh() {
      this.showDropdown_wh = !this.showDropdown_wh;
    },
    closeDropdownOnClickOutside_whall(event) {
      const multiselect = this.$refs.multiselectall;
      if (!(multiselect && multiselect.contains(event.target))) {
        this.showDropdown_wh = false;
      }
    },
    removeCity_wh(wh) {
      const index = this.editWarehouseid.indexOf(wh);
      if (index !== -1) {
        this.editWarehouseid.splice(index, 1);
      }
      this.updateSelectAllActive_wh();
    },
    toggleSelectAll_wh() {
      if (this.selectAllActive_wh) {
        this.editWarehouseid = [];
        this.editWarehouseid = [...this.editWarehouseoption];
        // this.editWarehouseid = this.editWarehouseoption.map(city => city.city);
      } else {
        this.editWarehouseid = [];
      }
    },
    updateSelectAllActive_wh() {
      // Update selectAllActive based on the number of selected cities
      this.selectAllActive_wh = this.editWarehouseid.length === this.editWarehouseoption.length;
    },

    checklength_wh(){
      console.log("this.editWarehouseid.length",this.editWarehouseid.length,this.editWarehouseoption.length)
      if (this.editWarehouseid.length == this.editWarehouseoption.length) {
        this.selectAllActive_wh = true
      }
      else{
        this.selectAllActive_wh = false
      }
    },
    
    editinfoModal: function(value) {
      console.log("AHHHHHHH",value);
      this.editWarehouseid.length = 0;
      this.editWarehouseoption.length = 0;
      this.editWarehouseoption = [];
      this.editWarehouseid = [];
      this.editvalueCity = [];
      this.selectAllActive = false;
      this.showDropdown = false;
      this.editWarehouse = [];
      this.showDropdown_wh = false;
      this.selectAllActive_wh = false;
      this.editCity = [];
      this.editvalueWH = [];
      this.editWarehouseoption = [];
      this.editWarehouseid = [];
      this.editoptionsCity = [];
      this.cityid =[];
      this.editWH =[];
      this.selected_Usertypeedit = '';
      this.editvalueWHupdate =[];
      this.sysusermasterid = value.sysusermasterid;
      this.Customer.email_id = value.sysemailid;
      this.Customer.first_name = value.userfirstname;
      this.Customer.sysusermasterid = value.sysusermasterid;
      this.Customer.last_name = value.userlastname;
      this.Customer.editusertype = value.user_type;
      this.Customer.editisactive = value.isactive;
      this.Customer.mobile_no = value.usermobilenumber;
      this.cityid = value.city;
      this.editWH = value.warehouseid;
      if (this.cityid.length>0) {
        this.cityid = value.city.split(",")
      }
      if (this.editWH.length>0) {
        this.editWH = value.warehouseid.split(",")
      }

      if (this.cityid != null) {
        this.editCity = value.city.split(",");
        this.editWarehouse = value.warehouseid.split(",");
        for (var i = 0; i < this.editCity.length; i++) {
          this.editvalueCity.push(this.editCity[i]);
        }
        for (var j = 0; j < this.editWarehouse.length; j++) {
          this.editvalueWH.push(this.editWarehouse[j]);
        }
        this.selectwarehouseListing(this.editvalueWH);
        this.warehouseListing();
        this.displayCity();
      }
      this.updateSelectAllActive();
      this.updateSelectAllActive_wh();
      this.editAgentMaster = !this.editAgentMaster;
    },

    callfunction(){
      this.warehouseListing();
    },

    selectwarehouseListing: function(value) {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.WHData = [];
      // this.optionsWH=[];
      this.editWarehouseoption = [];
      this.editWarehouseid = [];
      this.edittemp_WHcity = [];
      const WHObj = {
        cities: this.editvalueCity,
        sysusermasterid: `${userInfo.sysusermasterid}`,
        usertype: `${userInfo.user_type}`,
      };
      console.log("WHObj", WHObj);
      // return false;
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getCityBaseWareHouseList`, WHObj)
        .then((result) => {
          // console.log("YYY",result);
          if (result.body.returnmsg === "Successful") {
            // this.editWarehouseoption=[];

            this.WHData = result.body.returnvalue;
            // console.log("WHData",this.WHData);
            for (let j = 0; j < this.WHData.length; j++) {
              for (var k = 0; k < value.length; k++) {
                if (this.WHData[j].warehouseid == value[k]) {
                  let WH = {
                    name:
                      this.WHData[j].warehouseid +
                      " " +
                      this.WHData[j].vendorcity.substring(0, 3) +
                      " - " +
                      this.WHData[j].custvendorname,
                    id: this.WHData[j].warehouseid,
                  };
                  // this.editWarehouseoption.push(WH);
                  // this.editWarehouseid.push(WH.name);
                  this.editWarehouseid.push(WH);
                  this.changeWarehouse(this.editWarehouseid);
                  this.updateSelectAllActive();
                  this.updateSelectAllActive_wh();
                }
              }
            }
          } else {
            this.WHData = result.body.returnvalue;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    warehouseListing: function() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.WHData = [];
      this.edittemp_WHcity = [];
      this.editWarehouseid = [];
      this.editWarehouseoption = [];
      const WHObj = {
        cities: this.editvalueCity,
        sysusermasterid: `${userInfo.sysusermasterid}`,
        usertype: `${userInfo.user_type}`,
      };
      console.log("WHObj", WHObj);
      // return false;
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getCityBaseWareHouseList`, WHObj)
        .then((result) => {
          // console.log("YYY",result);
          if (result.body.returnmsg === "Successful") {
            this.editWarehouseoption = [];

            this.WHData = result.body.returnvalue;
            // console.log("WHData",this.WHData);
            for (let j = 0; j < this.WHData.length; j++) {
              let WH = {
                name:
                  this.WHData[j].warehouseid +
                  " " +
                  this.WHData[j].vendorcity.substring(0, 3) +
                  " - " +
                  this.WHData[j].custvendorname,
                id: this.WHData[j].warehouseid,
              };

              this.editWarehouseoption.push(WH);
    
              this.updateSelectAllActive();
              this.updateSelectAllActive_wh();
            }
          } else {
            this.WHData = result.body.returnvalue;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    changeWarehouse: function(value) {
      console.log("Value", value);
      this.edittemp_WHcity = [];

      for (var i = 0; i < this.WHData.length; i++) {
        for (var j = 0; j < value.length; j++) {
          if (this.WHData[i].warehouseid == value[j]) {
            let cityWH = {
              city: this.WHData[i].vendorcity,
              warehouseid: value[j].toString(),
            };

            this.edittemp_WHcity.push(cityWH);
          }
        }
      }
      this.updateSelectAllActive();
      this.updateSelectAllActive_wh();
    },

    editcancel: function() {
      this.Customer = {};
      this.editvalueCity = [];
      this.selectAllActive = false;
      this.showDropdown = false;
      this.editWarehouse = [];
      this.showDropdown_wh = false;
      this.selectAllActive_wh = false;
      this.editCity = [];
      this.editvalueWH = [];
      this.editWarehouseoption = [];
      this.editWarehouseid = [];
      this.editoptionsCity = [];
      this.cityid =[];
      this.editWH =[];
      this.selected_Usertypeedit = '';
      this.editvalueWHupdate =[];
      this.editAgentMaster = !this.editAgentMaster;
    },

    displayCity: function() {
      // this.isBusy = true;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const cityObj = {
        sysusermasterid: `${userInfo.sysusermasterid}`,
        usertype: `${userInfo.user_type}`,
      };
      console.log("cityObj", cityObj);
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getCityList`, cityObj)
        .then((result) => {
          console.log("YYY", result);
          if (result.body.returnmsg === "Successful") {
            this.cityData = result.body.returnvalue;
            for (let i = 0; i < this.cityData.length; i++) {
              let cities = {
                city: this.cityData[i].vendorcity,
              };
              this.optionsCity.push(cities);
              this.editoptionsCity.push(cities);
              this.updateSelectAllActive();
              this.updateSelectAllActive_wh();
            }
          } else {
            this.cityData = result.body.returnvalue;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },


    validateForm5(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.updateAdinAgent();
        }
      });
    },

    updateAdinAgent: function() {
      document.getElementById("overlayModal").style.display = "block";
      var result = [];
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      console.log("=================================",userInfo.hub_id)

        // if (this.valueWHcity.length==0) {
        //   this.$fire({
        //       text: "Please select WareHouse",
        //       type: "warning",
        //       timer: 30000,
        //     });
        //     document.getElementById("overlayModal").style.display = "none";
        //     return false
        // }
        if (this.editvalueCity.length === 0) {
          this.$fire({
              text: "Please Select City",
              type: "warning",
              timer: 30000,
            });
            document.getElementById("overlayModal").style.display = "none";
            return false
        }
        if (this.editWarehouseid.length === 0) {
            this.$fire({
              text: "Please Select Warehouse Id",
              type: "warning",
              timer: 30000,
            });
            document.getElementById("overlayModal").style.display = "none";
            return false
        }
        console.log("this.WHData",this.WHData)
        for (var i = 0; i < this.WHData.length; i++) {
          for (var j = 0; j < this.editWarehouseid.length; j++) {
            if (this.WHData[i].warehouseid == this.editWarehouseid[j].id) {
              let cityWH = {
                city: this.WHData[i].vendorcity,
                warehouseid: this.editWarehouseid[j].id.toString(),
              };

              this.valueWHcity.push(cityWH);
              console.log("valueWHcity", this.valueWHcity);
            }
          }
        }

      console.log("this.valueWHcity",this.valueWHcity)
        this.passwObj = {
          sysemailid: this.Customer.email_id,
          userfirstname: this.Customer.first_name,
          userlastname: this.Customer.last_name,
          user_type: this.Customer.editusertype,
          citywarehousedetails: this.valueWHcity,
          usermobilenumber: this.Customer.mobile_no,
          sysusermasterid: this.Customer.sysusermasterid,
          isactive : this.Customer.editisactive,
          hubid: userInfo.hub_id,
        };
     
      console.log("Obj1111111111", this.passwObj);
      // return false;

      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/updateAdminUser`, this.passwObj)
        .then((result) => {
          console.log("result",result);
          document.getElementById("overlayModal").style.display = "none";
          if (result.body.returnmsg === "Successful") {
            this.$fire({
              text: "Updated Successfully",
              type: "success",
              timer: 30000,
            });
            this.editAgentMaster = !this.editAgentMaster;
            this.customer = {};
            this.coordinatorList();
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },
formatToDDMMYYYY(date) {
    if (!date) return '';

    // Date object
    if (date instanceof Date) {
      if (isNaN(date.getTime())) return '';
      const d = date;
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      return `${yyyy}-${mm}-${dd}`;
    }

    // numeric timestamp
    if (typeof date === 'number' || (!isNaN(date) && String(date).length > 4)) {
      const d = new Date(Number(date));
      if (isNaN(d.getTime())) return '';
      return this.formatToDDMMYYYY(d);
    }

    // string handling
    if (typeof date === 'string') {
      const s = date.trim();

      // already DD-MM-YYYY
      if (/^\d{2}-\d{2}-\d{4}$/.test(s)) return s;

      // ISO / YYYY-MM-DD or YYYY-MM-DDTHH:MM:SS
      const isoMatch = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (isoMatch) {
        const [, y, m, d] = isoMatch;
        return `${d}-${m}-${y}`;
      }

      // slashed yyyy/mm/dd or dd/mm/yyyy
      if (/^\d{4}\/\d{2}\/\d{2}/.test(s)) { // yyyy/mm/dd
        const [y, m, d] = s.split(' ')[0].split('/'); 
        return `${d}-${m}-${y}`;
      }
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) { // dd/mm/yyyy
        return s.replace(/\//g, '-'); // convert to dd-mm-yyyy
      }

      // fallback: try Date parse (best-effort)
      const parsed = new Date(s);
      if (!isNaN(parsed.getTime())) return this.formatToDDMMYYYY(parsed);
    }

    return '';
  },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if(result){
          this.addCoordinatorForm()
        }
      })
      },
       addCoordinatorForm(){
        document.getElementById("overlay").style.display = "block";
        var userdata = localStorage.getItem("userData");
         var userInfo = JSON.parse(userdata);
          const joiningDateFormatted =
      this.employmentType === 'Contract'
        ? this.formatToDDMMYYYY(this.customer.dateofjoining)
        : '';
         const coordinatorObj = {
         sysemailid:this.customer.sysemailid,
         usertype:this.customer.usertype,
         userfirstname:this.customer.firstname,
         userlastname:this.customer.lastname,
         usermobilenumber:this.customer.mobilenumber,
         syspassword:this.customer.syspassword,
         isactive:this.customer.isactive,
         citywarehousedetails:this.temp_WHcity,
         created_by:`${userInfo.sysusermasterid}`,
         hub_id: userInfo.hub_id != null ? `${userInfo.hub_id}` : '',
         empId:this.customer.empId,
         isContract:this.employmentType == 'Contract' ? 'Yes':'No',
         cams_dept:"Logistics",
         cams_sub_dept:"Logistics",
         cams_designation:"Logistics User",
         cams_role:"Employee",
         cams_company_name:"Rocketbees",
         cams_hrms_dept:"Logistics",
         cams_hrms_designation:"Logistics Executive",
         cams_account_type:"Contract",
         system_name:"",
         gender:"",
         address:"",
         city:"",
         state:"",
         country:"",
         pincode:"",
         reporting_to:"",
         joining_date:joiningDateFormatted,
         hub_type:"rb_hub"

      };
      console.log("coordinatorObj",coordinatorObj);
        this.$http
              .post(
                `${ CONSTANTS.MIGRATION_API_URL}/systemUserMasterAddCoordinator`,coordinatorObj).then(result => {
                document.getElementById("overlay").style.display = "none";
               if (result.body.returnmsg === "Successful") {
                  // Utils.notify("Added Successfully", "success");
                  this.$fire({
                  text:"Added Successfully",
                  type: "success",
                  timer: 30000
                }); 
                  
                  this.customer = {};
                  this.errors.clear('form-1');
                   var adduser = document.getElementById("my-collapse");
                  adduser.style.display = "none"; 
                  this.valueCity=[];
                  this.temp_WHcity=[];
                  this.coordinatorList();
                  this.displayCity();

                  // this.$router.push('/ftl/adminuser_mr');
                } else {
                    this.$fire({
                    text:result.body.returnvalue,
                    type: "error",
                    timer: 30000
                  }); 
                }
                
              })
              .catch(ex => {
                console.log("error", ex);
              });
       },
       coordinatorList(){
        this.coodinatorItems=[];
        this.totalRows=0;
        this.isBusy=true;
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        console.log("userInfo------------------------",userInfo)
        this.user_type=userInfo.user_type;
        const obj={
          sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype:`${userInfo.user_type}`,
          hub_id: userInfo.hub_id != null ? `${userInfo.hub_id}` : '',
        }
        //checkAvailableCoordinatorandSubcoordinator old
        this.$http
              .post(
                `${ CONSTANTS.MIGRATION_API_URL}/checkAvailableCoordinatorandSubcoordinatorHub`,obj).then(result => {
                  this.isBusy=false;
                  if (result.body.returnmsg === "Successful") {
                   this.coodinatorItems=result.body.returnvalue;
                   // console.log("YYY",this.coodinatorItems.length);
                   // this.co_sysmaster_id=this.coodinatorItems[0].sysusermasterid;
                   this.totalRows=result.body.returnvalue.length;
                   // console.log("Test",this.totalRows);
                  }else{
                    this.coodinatorItems=[];
                    this.totalRows=0;
                  }
                }).catch(ex => {
                console.log("error", ex);
              });
       },
    
    //   displayCity: function() {
     
    //   // this.isBusy = true;
    //   var userdata = localStorage.getItem("userData");
    //   var userInfo = JSON.parse(userdata);
    //   const cityObj = {
    //       sysusermasterid:`${userInfo.sysusermasterid}`,
    //       usertype:`${userInfo.user_type}`,
    //   };
    //   // console.log('cityObj',cityObj);
    //   this.$http
    //     .post(
    //       `${
    //         CONSTANTS.MIGRATION_API_URL
    //       }/getCityList`,
    //       cityObj
    //     )
    //     .then(result => {
    //       // console.log("YYY",result);
    //       if (result.body.returnmsg === 'Successful') {
           
    //         this.cityData  = result.body.returnvalue;
            
    //       for(let i = 0; i < this.cityData.length; i++) {
    //         let cities = {
    //                 city: this.cityData[i].vendorcity,
    //               }
    //         this.optionsCity.push(cities);
                  
    //         }
           
    //       } else {
            
    //         this.cityData  = result.body.returnvalue;
            
    //       }
    //     })
    //     .catch(ex => {
    //       console.log("error", ex);
    //     });
     
    // },
 
       selectedCity:function(value){
        
        // console.log("jjjj",value);
        // this.tempCity=value;
        this.valueWH=[];
        this.temp_WHcity=[];
        this.selectedWarehouse();
     
      },
   selectedWarehouse:function(){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.WHData=[];
      // this.optionsWH=[];
      const WHObj = {
        cities:this.valueCity,
        sysusermasterid:`${userInfo.sysusermasterid}`,
        usertype:`${userInfo.user_type}`,
      };
      // console.log('WHObj',WHObj);
      // return false;
      this.$http
        .post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getCityBaseWareHouseList`,
          WHObj
        )
        .then(result => {
          // console.log("YYY",result);
          if (result.body.returnmsg === 'Successful') {
            this.optionsWH=[];
           
            this.WHData  = result.body.returnvalue;
            // console.log("WHData",this.WHData);
         for(let j = 0; j < this.WHData.length; j++) {
            let WH = {
                    name: this.WHData[j].warehouseid + " " + (this.WHData[j].vendorcity.substring(0,3)) + " - " + this.WHData[j].custvendorname,
                    id: this.WHData[j].warehouseid,
                  }
                 
              this.optionsWH.push(WH);
             
              }
            
          } else {
           
            this.WHData  = result.body.returnvalue;
            
          }
        })
        .catch(ex => {
          console.log("error", ex);
        });

   },
   selectedWH:function(value){

       this.temp_WHcity=[];
      
       for(var i=0;i<this.WHData.length;i++){
         for(var j=0;j<value.length;j++){
        if(this.WHData[i].warehouseid == value[j]){
       let cityWH = {
        city: this.WHData[i].vendorcity,
        warehouseid:value[j].toString(),
       }
    
       this.temp_WHcity.push(cityWH);
  
       }
      }
     }
    },
    assignPincodes(value){
      this.co_sysmaster_id=value.sysusermasterid;
      this.user_type=value.user_type;
      // this.coSystemid=value.sysusermasterid.toString();
      this.assignedPincode=[];
      this.optionsPincode=[];
      this.pincodeAssigntoAdmin=[];
      this.assignPintoCo();
      this.pincodeAssign();
      this.pincodeAloocationModal=true;
      },
    addCoordinator(){
      this.errors.clear("form-1");
      var adduser = document.getElementById("my-collapse");
      adduser.style.display = "block";
     },
     refresh:function() {
      var adduser = document.getElementById("my-collapse");
      adduser.style.display = "none";
      this.customer = {};
      this.errors.clear('form-1');
      this.currentPage=1;
      this.displayCity();
    },
    pincodeAssign(){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        this.optionsPincodes=[];
        this.pincodeAssigntoAdmin=[];
       const obj = {
        sysusermasterid:`${userInfo.sysusermasterid}`,
        usertype:`${userInfo.user_type}`
        // sysusermasterid:this.adminSystemid,
       };
      
     
        // console.log(obj);
        // return false;
     
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getPincodesAgainstAdminOrCoordinator`,obj)
        .then((result) => {
           // console.log("Result",result);
          if (result.body.returnmsg === 'Successful') {
             this.pincodeAssigntoAdmin=result.body.returnvalue;  
             // console.log("test",this.pincodeAssigntoAdmin) ;
           for(let i = 0; i < this.pincodeAssigntoAdmin.length; i++) {
            let pincodes = {
             name:this.pincodeAssigntoAdmin[i].service_pincode + " - " + this.pincodeAssigntoAdmin[i].city,
             id: this.pincodeAssigntoAdmin[i].service_pincode.toString(),
           }
           this.optionsPincodes.push(pincodes);
           // console.log("YYY",this.optionsPincodes);
          }
          
          } else {
            this.pincodeAssigntoAdmin=[];    
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
      },
      validateForm2(scope) {
      this.$validator.validateAll(scope).then(result => {
        if(result){
          this.assignPincodeToCo()
        }
      })
      },
      assignPincodeToCo(){
        document.getElementById("overlayModal").style.display = "block";
         var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
       const obj = {
        pincodesld:this.assignedPincode,
        coordinator_sysmasterid:`${this.co_sysmaster_id}`,
        usertype:`${this.user_type}`,
       };
      
     
        // console.log(obj);
        // return false;
     
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/assignCoordinatorToAdminOrSubCoToCordinator`,obj)
        .then((result) => {
           // console.log("Result",result);
           document.getElementById("overlayModal").style.display = "none";
          if (result.body.returnmsg === 'Successful') {
            
               this.$fire({
                 text:'Pincode Assign To Coordinator',
                 type:'success',
                 timer:3000
               })
              this.assignPintoCo();
             this.pincodeAloocationModal=false; 
           } else {
            this.$fire({
              text:result.body.returnvalue,
              type:'error',
              timer:3000
            })
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
      },
      CloseAllocatePincodeModal(){
    this.pincodeAloocationModal=false;
   },
    assignPintoCo(){
       var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        this.coAssignPincode=[];
       const obj = {
        sysusermasterid: `${this.co_sysmaster_id}`,
        usertype:`${this.user_type}`,
       };
      
     
        // console.log(obj);
        // return false;
     
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getPinCodesForCoordinatorandSubcoordinator`,obj)
        .then((result) => {
           // console.log("Result",result);
          if (result.body.returnmsg === 'Successful') {
            
          this.assignedPincodeToCo=result.body.returnvalue;
          for(let i = 0; i < this.assignedPincodeToCo.length; i++) {
            let pincodes = {
             name:this.assignedPincodeToCo[i].service_pincode + " - " + this.assignedPincodeToCo[i].city,
             id: this.assignedPincodeToCo[i].service_pincode.toString(),
           }
          
           
           this.coAssignPincode.push(pincodes);
            }
            this.checkPincodeAssign(this.coAssignPincode);
           } else {
              this.assignedPincodeToCo=[];
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    checkPincodeAssign(value){
        // console.log("Valureee",value)
        for(let i=0;i<value.length;i++){
          this.optionsPincodes.push(value[i]);
          this.assignedPincode.push(value[i].id);
        }
      },
    viewZoneList(value){
      this.zone_id=value;
      this.viewZone=true;
      this.viewZoneListing();
    },
    modalCancel(){
      this.viewZone=false;
    },
    viewZoneListing(){
        this.isBusyzone=true;
       const obj = {
        
        zone_id:this.zone_id,
       };
      
     
        // console.log(obj);
        // return false;
     
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getLoadListingAgainstZone`,obj)
        .then((result) => {
          this.isBusyzone=false;
           // console.log("Result",result);
          if (result.body.returnmsg === 'Successful') {
            
             this.zoneitems=result.body.returnvalue;
             this.zonetotalRows=result.body.returnvalue.length;

           } else {
              this.zoneitems=[];
              this.zonetotalRows=0;
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    viewMPSList(value){
       this.parent_awb=value;
      this.viewMPSCout=true;
      this.viewMPSListing();

    },
    mpsmodalCancel(){
      this.viewMPSCout=false;
    },
    viewMPSListing(){
       this.isBusymps=true;
       const obj = {
        
        parentawb:this.parent_awb,
       };
      
     
        // console.log(obj);
        // return false;
     
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getMpsListingAgainstParentawb`,obj)
        .then((result) => {
          this.isBusymps=false;
           // console.log("Result",result);
          if (result.body.returnmsg === 'Successful') {
            
             this.mpsitems=result.body.returnvalue;
             this.mpstotalRows=result.body.returnvalue.length;

           } else {
              this.mpsitems=[];
              this.mpstotalRows=0;
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
  
  onlyNumberInput(event) {
    const charCode = event.which ? event.which : event.keyCode;
    // Allow only digits (0–9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  },

  
  getuserlistcoordinatorformultiselect: function() {
      this.valuemultipleuser = []
      this.userstatus = null
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      console.log("userInfo------------------------",userInfo)
      this.user_type=userInfo.user_type;

      if (!userdata) {
          console.error("userData not found");
          return;
      }

      
    const obj={
      sysusermasterid:`${userInfo.sysusermasterid}`,
      usertype:`${userInfo.user_type}`,
      hub_id: userInfo.hub_id != null ? `${userInfo.hub_id}` : '',
    }

      console.log("Request:", obj);

      this.$http
          .post(
              `${CONSTANTS.MIGRATION_API_URL}/checkAvailableCoordinatorandSubcoordinatorHub`,
              obj
          )
          .then((result) => {
              console.log("API Response:", result.body);

              if (
                  result.body &&
                  result.body.returnmsg === "Successful"
              ) {
                  const itemdata =
                      result.body.returnvalue || [];
                  console.log(itemdata)
                  this.multiItems = itemdata.map((item) => ({
                      name:
                          `${item.sysusermasterid || ""}-${item.userfirstname || ""} ${item.userlastname || ""}-${item.usermobilenumber || ""}`.trim(),
                      id: item.sysusermasterid,
                  }));

                  console.log(
                      "Loaded Users:",
                      this.multiItems
                  );
              } else {
                  this.multiItems = [];

                  this.$fire({
                      text: "No records found",
                      type: "warning",
                      timer: 3000,
                  });
              }
          })
          .catch((error) => {
              console.error(
                  "Error loading users:",
                  error
              );

              this.multiItems = [];

              this.$fire({
                  text: "Failed to load users",
                  type: "error",
                  timer: 3000,
              });
          });
  },

  selectAllUsers() {
      this.valuemultipleuser = [...this.multiItems];
  },

  saveSelectedUsers() {

      if(this.userstatus === null || this.userstatus == ''){
          this.$fire({
              text: "please select status as well",
              type: "warning",
              timer: 3000,
          });
          return;
      }
      
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      const selectedIds =
          this.valuemultipleuser.map(
              user => user.id
          );

      console.log("Selected User IDs:", selectedIds);

      const payload = {
          userids: selectedIds,
          userstatus: this.userstatus,
          lastmodifiedby: `${userInfo.sysemailid}`
      };

      this.$http
          .post(
              `${CONSTANTS.MIGRATION_API_URL}/multipleUserStatusUpdate`,
              payload
          )
          .then(result => {
              if(result.body.returnmsg == 'Successful'){
                  this.$fire({
                  text: "Updated Successfully",
                  type: "success",
                  timer: 3000,
                  });
                  this.coordinatorList();
                  this.showmltiselectpopup = false;
                  
              }else{
                  this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 3000,
                  });
              }
          })
            .catch((ex) => {
            console.log("error", ex);
                this.coordinatorList();
                  this.showmltiselectpopup = false;
                  
          });
          
      }


   },
   
  };
</script>
<style>
.selected-cities {
  display: flex;
  flex-wrap: wrap;
}
.multiselect {
  position: inherit;
}

.select-box {
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}

.arrow {
  float: right;
}

.down::before {
  content: "▼";
}

.up::before {
  content: "▲";
}

.multiselect .dropdown {
  position: inherit;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  background-color: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

}

.multiselect .checkbox {
 padding: 5px 0px 0px 10px;
  font-size: 15px;
}

.multiselect .checkbox input[type="checkbox"] {
  margin-right: 5px;
}
</style>